(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hvac-diagnoser"] && !Shopify.designMode) return;
  try {
    
class HeatingAirDiagnoser extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.data = JSON.parse(this.querySelector('[data-hvac-data]').textContent);
    this.screen = this.querySelector('[data-hvac-screen]');
    this.history = [];
    this.current = 'safety';
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-action]');
      if (!button || !this.contains(button)) return;
      if (button.dataset.action === 'answer') this.answer(Number(button.dataset.choice));
      if (button.dataset.action === 'back') this.back();
      if (button.dataset.action === 'restart') this.restart();
      if (button.dataset.action === 'print') window.print();
    });
    this.render(false);
  }
  el(tag, text, cls) {
    const element = document.createElement(tag);
    if (text) element.textContent = text;
    if (cls) element.className = cls;
    return element;
  }
  button(text, action, cls) {
    const b = this.el('button', text, cls);
    b.type = 'button';
    b.dataset.action = action;
    return b;
  }
  system() { return this.history.find(x => x.node === 'system')?.index; }
  choices() {
    const node = this.data.nodes[this.current];
    let indices = node.choices.map((_, i) => i);
    if (this.current === 'symptom' && this.system() === 2) indices = indices.filter(i => i !== 1);
    if (this.current === 'symptom' && this.system() === 0) indices = indices.filter(i => i !== 2);
    if (this.current === 'water' && this.system() !== 1) indices = indices.filter(i => i !== 3);
    if (this.current === 'noise' && this.system() !== 1) indices = indices.filter(i => i !== 3);
    return indices;
  }
  answer(index) {
    if (this.current.startsWith('!') || !this.choices().includes(index)) return;
    const selected = this.data.nodes[this.current].choices[index];
    this.history.push({node:this.current, index});
    this.current = selected.next;
    this.render();
  }
  back() {
    const previous = this.history.pop();
    if (previous) { this.current = previous.node; this.render(); }
  }
  restart() { this.history = []; this.current = 'safety'; this.render(); }
  heading(text) {
    const h = this.el('h3', text, 'had-question');
    h.tabIndex = -1;
    return h;
  }
  list(items) {
    const list = this.el('ul');
    items.forEach(text => list.append(this.el('li', text)));
    return list;
  }
  filteredParts(result) {
    const system = this.system();
    return result.parts.filter(part => {
      if (['sensor','ignitor'].includes(part)) return system === 2;
      if (['capacitor','contactor','transformer'].includes(part)) return system !== 4 && system !== 5 && system !== undefined;
      return true;
    });
  }
  render(focus = true) {
    const {ui,nodes,results,parts} = this.data;
    this.screen.replaceChildren();
    const result = this.current.startsWith('!') ? results[this.current.slice(1)] : null;
    this.classList.toggle('had-has-result', Boolean(result));
    this.classList.toggle('had-danger', result?.severity === 'danger');
    let heading;
    if (!result) {
      const node = nodes[this.current];
      this.screen.append(this.el('p', `${ui.step} ${this.history.length + 1}`, 'had-step'));
      heading = this.heading(node.title);
      this.screen.append(heading, this.el('p',node.note,'had-note'));
      const answers = this.el('div',null,'had-answers');
      this.choices().forEach(index => {
        const b = this.button(node.choices[index].label,'answer','had-answer');
        b.dataset.choice = index;
        answers.append(b);
      });
      this.screen.append(answers);
    } else {
      const danger = result.severity === 'danger';
      this.screen.append(this.el('p', danger ? ui.emergency : ui.result, 'had-step'));
      heading = this.heading(result.title);
      this.screen.append(heading);
      if (!danger) this.screen.append(this.el('p',ui.not_diagnosis,'had-note'));
      this.screen.append(this.el('h4',ui.causes),this.list(result.causes),this.el('h4',ui.checks),this.list(result.checks));
      if (!danger) {
        const panel = this.el('div',null,'had-parts');
        panel.append(this.el('h4',ui.parts));
        const recommendations = this.filteredParts(result);
        if (!recommendations.length) panel.append(this.el('p',ui.none));
        else {
          panel.append(this.el('p',ui.part_note,'had-note'));
          recommendations.forEach(key => {
            const part = parts[key];
            const card = this.el('article',null,'had-part');
            card.append(this.el('h5',part.title),this.el('p',part.match));
            const a = this.el('a',ui.catalog);
            const search = new URL(this.dataset.searchUrl || '/search',window.location.origin);
            search.searchParams.set('type','product');
            search.searchParams.set('q',part.query);
            a.href = search.pathname + search.search;
            card.append(a);
            panel.append(card);
          });
          panel.append(this.el('p',ui.catalog_note,'had-small'));
        }
        this.screen.append(panel);
        const fit = this.el('div',null,'had-fit');
        fit.append(this.el('h4',ui.fit),this.el('p',ui.need_model));
        this.screen.append(fit);
      }
      const details = this.el('details',null,'had-summary');
      details.append(this.el('summary',ui.summary));
      const answers = this.el('dl');
      this.history.forEach(({node,index}) => {
        answers.append(this.el('dt',nodes[node].title),this.el('dd',nodes[node].choices[index].label));
      });
      details.append(answers);
      this.screen.append(details);
    }
    const nav = this.el('div',null,'had-controls');
    if (this.history.length) nav.append(this.button(ui.back,'back','had-secondary'));
    if (this.history.length) nav.append(this.button(ui.restart,'restart','had-secondary'));
    if (result) nav.append(this.button(ui.print,'print','had-secondary'));
    this.screen.append(nav);
    if (focus) heading.focus({preventScroll:true});
  }
}
if (!customElements.get('heating-air-diagnoser')) customElements.define('heating-air-diagnoser', HeatingAirDiagnoser);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
